import Popup from 'reactjs-popup';
import styled, { keyframes } from 'styled-components';

// animations
const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

const StyledPopup = styled(Popup)`
  &-overlay {
    background: rgba(0, 0, 0, 0.15); /* Dark overlay background */
	}

  &-content {
    position: fixed !important;
		bottom: 0;
    height: auto;
    width: 100%;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform: translateY(100%);
		border:none;
		padding: .85rem 1rem 1rem;

		&.sidepanel-modal-content{
			&.open-content {
     	animation: ${slideUp} 0.4s ease forwards;
			background:var(--modalSidebarBG);
			}

			&.close-content {
				animation: ${slideDown} 0.4s ease forwards;
			}
				
			animation: ${slideDown} 0.4s ease forwards;
		}

    

  }
	
`;

export { StyledPopup };
export const ModalContent = styled.div`
`; 
